import type { UploadedDocument } from '@urbanx/agx.agencies.client';
import { createAgxForm, createFormDefinition } from '@urbanx/agx.forms';
import { isValidPhoneNumber } from '@urbanx/agx.ui-components2';
import { z } from 'zod';

const isUploadedDocument = (value: unknown): value is UploadedDocument =>
  Boolean(value) && typeof value === 'object' && !Array.isArray(value);

export const profileSettingsSchema = z.object({
  firstName: z.string().trim().min(1, 'Enter a first name'),
  lastName: z.string().trim().min(1, 'Enter a last name'),
  title: z.string(),
  phone: z
    .string()
    .refine((phone) => !phone || isValidPhoneNumber(phone), 'Enter a valid phone number'),
  photo: z.custom<UploadedDocument>(isUploadedDocument, 'Invalid uploaded document').optional(),
});

export type ProfileSettingsValues = z.input<typeof profileSettingsSchema>;

export const profileSettingsFormDefinition = createFormDefinition({
  id: 'agent-profile-settings',
  schema: profileSettingsSchema,
  fieldOrder: ['firstName', 'lastName', 'title', 'phone', 'photo'],
  resolveFields: () => ({
    firstName: { active: true, visible: true, disabled: false, required: true },
    lastName: { active: true, visible: true, disabled: false, required: true },
  }),
});

export const ProfileForm = createAgxForm(profileSettingsFormDefinition);
